<template>
  <div>
    <b-navbar
      class="nav-style"
      :shadow="true"
      :fixed-top="true"
    >
      <template #brand>
        <b-navbar-item
          tag="router-link"
          :to="{ path: '/dashboard' }"
        >
          <img
            class="logo-style"
            src="@/assets/logo-villa-mobile.svg"
          >
        </b-navbar-item>
      </template>
      <template #start>
        <b-navbar-item class="navtext-style">
          Online Store Management
        </b-navbar-item>
        <b-navbar-item>
          <b-button
            tag="router-link"
            :to="{ path: '/dashboard' }"
          >Company Mode</b-button>
        </b-navbar-item>
        <b-navbar-item>
          <b-button
            tag="router-link"
            :to="{ path: '/branch' }"
          >Branch Mode</b-button>
        </b-navbar-item>
        <b-navbar-item>
          <b-button
            tag="router-link"
            :to="{ path: '/summary' }"
          >Summary Mode</b-button>
        </b-navbar-item>
        <b-navbar-item>
          <b-button
            tag="router-link"
            :to="{ path: '/executive-summary' }"
          >Executive Summary Mode</b-button>
        </b-navbar-item>
      </template>

      <template #end>
        <b-navbar-item>
          <b-button
            disabled
            @click="exportItem = true"
          >EXPORT</b-button>
          <b-modal
            v-model="exportItem"
            :width="940"
          >
            <exportToCSV />
          </b-modal>
        </b-navbar-item>
        <b-navbar-item @click="open = true">
          <b-button
          type="is-ghost">
            <font-awesome-icon
              icon="fa-solid fa-bars"
              size="1x">
            </font-awesome-icon>
          </b-button>
        </b-navbar-item>
      </template>
    </b-navbar>
    <!-- <section>
      <b-sidebar
        type="is-white"
        :fullheight="true"
        :open.sync="open"
        :right="true"
      >
        <div class="p-1">
          <img src="@/assets/logo-villa-mobile.svg" />
          <b-menu>
            <b-menu-list label="Menu">
               <b-menu-item
                v-for="(text, i) in title"
                :key="i"
                :label="text"
                :icon="title_icon[i]"
                icon-pack="fas"
              ></b-menu-item>
              <b-menu-item
                :label="title.sec1.title"
                icon="fas fa-info"
                icon-pack="fas"
                @click="clickScrollGoTo(title.sec1.title)"
              >
              </b-menu-item>
              <b-menu-item
                :label="title.sec2.title"
                icon="far fa-chart-bar"
                icon-pack="fas"
                @click="clickScrollGoTo(title.sec2.title)"
              >
                <b-menu-item
                  v-for="(text, i) in subTitleDP"
                  :key="i"
                  :label="text"
                ></b-menu-item>
              </b-menu-item>
            </b-menu-list>
            <b-menu-list label="Actions">
              <b-menu-item
                icon="logout"
                label="Logout"
                tag="router-link"
                :to="{ path: '/' }"
              ></b-menu-item>
            </b-menu-list>
          </b-menu>
        </div>
      </b-sidebar>
    </section> -->
  </div>
</template>

<script>
import { titleText } from '@/setting/titleText.js'
import exportToCSV from '@/components/exportToCSV.vue'

export default {
  components: {
    exportToCSV
  },
  // props: ['allRef'],
  data () {
    return {
      exportItem: false,
      title: titleText,
      open: false,
      subTitleDP: [
        'Daily Status',
        'Current Status In Hours',
        'Success Order In Hours'
      ],
      title_icon: [
        'fas fa-info',
        'far fa-chart-bar',
        'fas fa-info',
        'far fa-chart-bar',
        'fas fa-info'
      ]
    }
  },
  methods: {
    clickScrollGoTo (ref) {
      this.$emit('allRef', { whereRef: ref })
      // this.$emit('allRef', { label: this.label })
    }
  }
}
</script>

<style scoped>
.nav-footer {
  height: 2px;
  margin-bottom: 0px;
  padding-bottom: 0px;
}
.logo-style {
  max-width: 100%;
  height: auto;
}
.navtext-style {
  font-size: 150%;
}
</style>
